import React, { useState } from 'react';
import DOMPurify from 'dompurify';

import './TRightComponent.css'

function isHtmlString(str) {
    // Very simple heuristic: contains any HTML tags?
    return /<[a-z][\s\S]*>/i.test(str);
}

const TRightComponent = (data) => {

    const content = data?.data;

    if (isHtmlString(content)) {
        return (
            <div
                className="html-content"
                dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(content)
                }}
            />
        );
    } else {
        return <div>{content}</div>;
    }
};

export default TRightComponent;